
import { Component, Prop, Vue } from 'vue-property-decorator'
import JobHistory from '@/components/widgets/history/JobHistory.vue'
import { SocketActions } from '@/api/socketActions'

@Component({
  components: {
    JobHistory
  }
})
export default class PrinterHistoryCard extends Vue {
  @Prop({ type: Boolean, default: false })
  public menuCollapsed!: boolean

  handleRemoveAll () {
    this.$confirm(
      this.$tc('app.history.msg.confirm_jobs'),
      { title: this.$tc('app.general.label.confirm'), color: 'card-heading', icon: '$error' }
    )
      .then(res => {
        if (res) {
          SocketActions.serverHistoryDeleteJob('all')
        }
      })
  }

  handleLoadAll () {
    SocketActions.serverHistoryList({ limit: 0 })
  }
}
